module.exports = __webpack_public_path__ + "static/img/icon_94_jinyan.0f5e89a8.png";